import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function MSWordIcon({ className, fill, height, width }: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      height={height ?? 24}
      viewBoxDimensions="0 0 24 24"
      width={width ?? 24}
    >
      <g fill={fill ?? IconColors.Blue} fillRule="evenodd">
        <path d="M21.625 20.938c0 .759-.616 1.375-1.375 1.375H3.75c-.76 0-1.375-.616-1.375-1.375V3.063c0-.76.616-1.376 1.375-1.376h13.791c.36 0 .704.14.96.391l2.709 2.643c.265.259.415.614.415.984v15.233zM5 17.25a3.75 3.75 0 0 0 3.75-3.75V12A3.75 3.75 0 0 0 5 8.25a.75.75 0 0 0-.75.75v7.5c0 .414.336.75.75.75zm2.25-3.75a2.25 2.25 0 0 1-1.5 2.122V9.878A2.25 2.25 0 0 1 7.25 12v1.5zm4.761-5.25a2.25 2.25 0 0 0-2.25 2.25V15a2.25 2.25 0 1 0 4.5 0v-4.5a2.25 2.25 0 0 0-2.25-2.25zm0 1.5a.75.75 0 0 1 .75.75V15a.75.75 0 1 1-1.5 0v-4.5a.75.75 0 0 1 .75-.75zm7.01-1.5a3.75 3.75 0 0 0-3.75 3.75v1.5a3.75 3.75 0 0 0 3.75 3.75.75.75 0 0 0 0-1.5 2.25 2.25 0 0 1-2.25-2.25V12a2.25 2.25 0 0 1 2.25-2.25.75.75 0 0 0 0-1.5z" />
      </g>
    </SimpleIcon>
  );
}
